import {
    type AiAgentId,
    CONVERSATIONAL_MM_AGENT,
    SPROUT_AGENT,
} from '@fruitful/llm-service-shared';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { BodyMediumEmphasized, Row, RowList, YStack } from 'smoothie';

import { IS_LOCAL } from '../../config/FruitfulEnvironment';
import { adminUserAtom } from '../../entities/entityAtoms';
import { AdminUserRole } from '../../entities/entityTypes';
import { AiWeatherModal } from '../examples/weather/components/AiWeatherModal';

const DASHBOARD_AGENTS = [CONVERSATIONAL_MM_AGENT, SPROUT_AGENT];

export const AiDashboardAgentNav = ({
    selectedAgentId,
    onSelectAgent,
}: {
    selectedAgentId: AiAgentId;
    onSelectAgent: (agentId: AiAgentId) => void;
}) => {
    const adminUser = useAtomValue(adminUserAtom);
    const [isAiWeatherModalOpen, setIsAiWeatherModalOpen] = useState(false);
    const canUseAiWeather =
        IS_LOCAL || adminUser.role === AdminUserRole.ENGINEER;

    return (
        <YStack
            width={225}
            $md={{ width: 275 }}
            $lg={{ width: 325 }}
            flexShrink={0}
            gap={12}
            padding="$4"
            backgroundColor="white"
        >
            <BodyMediumEmphasized>Agents</BodyMediumEmphasized>
            <RowList>
                {DASHBOARD_AGENTS.map((agent) => {
                    const isSelected = agent.id === selectedAgentId;
                    return (
                        <Row
                            key={agent.id}
                            title={agent.name}
                            onPress={() => {
                                onSelectAgent(agent.id);
                            }}
                            containerProps={
                                isSelected
                                    ? {
                                          backgroundColor: '$green100',
                                          hoverStyle: {
                                              backgroundColor: '$green100',
                                          },
                                          accessibilityRole: 'tab',
                                          accessibilityState: {
                                              selected: true,
                                          },
                                      }
                                    : {
                                          accessibilityRole: 'tab',
                                          accessibilityState: {
                                              selected: false,
                                          },
                                      }
                            }
                            titleProps={
                                isSelected ? { color: '$green900' } : undefined
                            }
                        />
                    );
                })}
            </RowList>

            {canUseAiWeather && (
                <>
                    <BodyMediumEmphasized marginTop={8}>
                        Manage
                    </BodyMediumEmphasized>
                    <RowList>
                        <Row
                            title="Debug (AI Weather)"
                            onPress={() => {
                                setIsAiWeatherModalOpen(true);
                            }}
                        />
                    </RowList>
                </>
            )}

            {canUseAiWeather && (
                <AiWeatherModal
                    isOpen={isAiWeatherModalOpen}
                    onClose={() => {
                        setIsAiWeatherModalOpen(false);
                    }}
                />
            )}
        </YStack>
    );
};
